import { useContext } from 'react';
import { motion } from "framer-motion"
import { NavigationContext } from "@/providers/navigationProvider";
import styles from './styles.module.scss';
import TopLevel from './TopLevel';
import TitleBar from './TitleBar';
import MainMenu from './MainMenu';
import DemoButton from "./DemoButton";
import LanguageSelector from "./LanguageSelector";
import Glyph from '../Glyph';

const Menu = () => {
    const context = useContext(NavigationContext);
    const {open} = context || {};
    
    const animationConfig = {
        opacity: open ? 1 : 0,
        y:  open ? 0 :  '-100%',
        transition: {
            type: "tween",  // Change the type to 'tween' to avoid the bounce
            ease: "easeInOut",  // You can adjust the easing function
            duration: 0.25  // You can also adjust the duration
        }
    }

    return (
        <motion.div animate={animationConfig} className={styles.navigationMenu}>
            <div className='container'>
                <div className={styles.navigationMenu__top}>
                    <DemoButton />
                    <LanguageSelector />
                </div>
                <div className={styles.navigationMenu__inner}>
                    <TopLevel />
                    <div  className={styles.navigationMenu__titleMenuWrap}>
                        <TitleBar />
                        <MainMenu />
                    </div>
                </div>
            </div>
            <Glyph />
        </motion.div>
    );
}

export default Menu;